// extracted by mini-css-extract-plugin
export default {"content":"YpOmyE","container":"Hfo6pG","slide":"FgHUvT"};